import React, { useRef } from 'react';
import ErrorBoundary from '../../../../components/error-boundary';
import { IProductPageTabsProps } from './types';
import {
  PropertiesTabContent,
  StatisticsTabContent,
  TabContent,
} from './styles';
import {
  ProductTabMain,
  ProductTabProperties,
  ProductTabReviews,
  ProductTabStatistics,
} from './sections';
import { useLocation } from 'react-router-dom';
import { delayedScrollIntoView } from './utils';

const ProductTabs: React.FC<IProductPageTabsProps> = props => {
  const {
    routeSection,
    isPreRelease,
    product,
    similarProducts,
    importantDates,
    fetchMoreData,
    getRecommendationsLink,
    userReviews,
    currentCampaign,
    userReviewsSummary,
    shouldRenderAllTabs,
  } = props;
  const location = useLocation();
  const firstRender = useRef(true);

  if (!product) {
    return null;
  }

  if (
    shouldRenderAllTabs &&
    location.hash !== '' &&
    location.hash !== '#main' &&
    firstRender.current
  ) {
    firstRender.current = false;
    const targetElement = document.getElementById(location.hash)!;
    delayedScrollIntoView(targetElement);
  }

  return (
    <>
      <TabContent id="#main">
        {(routeSection === 'main' || shouldRenderAllTabs) && (
          <ProductTabMain
            isPreRelease={isPreRelease}
            product={product}
            similarProducts={similarProducts}
            getRecommendationsLink={getRecommendationsLink}
            currentCampaign={currentCampaign}
          />
        )}
      </TabContent>

      <PropertiesTabContent id="#properties">
        {(routeSection === 'properties' || shouldRenderAllTabs) && (
          <ErrorBoundary onError={returnNull}>
            <ProductTabProperties
              product={product}
              shouldRenderAllTabs={shouldRenderAllTabs}
            />
          </ErrorBoundary>
        )}
      </PropertiesTabContent>

      <TabContent id="#reviews">
        {(routeSection === 'reviews' || shouldRenderAllTabs) && (
          <ErrorBoundary onError={returnNull}>
            <ProductTabReviews
              product={product}
              shouldRenderAllTabs={shouldRenderAllTabs}
              userReviews={userReviews}
              userReviewsSummary={userReviewsSummary}
            />
          </ErrorBoundary>
        )}
      </TabContent>

      <StatisticsTabContent id="#statistics">
        {(routeSection === 'statistics' || shouldRenderAllTabs) && (
          <ErrorBoundary onError={returnNull}>
            <ProductTabStatistics
              product={product}
              shouldRenderAllTabs={shouldRenderAllTabs}
              importantDates={importantDates}
              fetchMoreData={fetchMoreData}
            />
          </ErrorBoundary>
        )}
      </StatisticsTabContent>
    </>
  );
};

const returnNull = () => null;

export default ProductTabs;
